// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Botp","notes":"Notes_notes__1dbBD","note":"Notes_note__1OnqX","markdown":"Notes_markdown__2BZVY"};